import { styled, useAssetsPath } from '@obvio/app'
import { List, Section } from '@obvio/ui'

import { Accordion, AccordionTitle } from '../Accordion'
import { FadeIn } from '../FadeIn'

import type { Data } from '@/pages/artist/[name]'
import type { ReactElement } from 'react'

const InfoWrap = styled.div`
  display: flex;
  justify-content: space-between;
  padding-bottom: ${(theme) => theme.spacing.extraSmall};
  border-bottom: thin solid black;
  align-items: center;
`

type DataListProps = {
  data?: { title: string }[]
  title: string
  index: number
}

function DataList({ data, title, index }: DataListProps): ReactElement | null {
  if (!data || data?.length === 0) {
    return null
  }

  return (
    <Accordion.Element
      index={index}
      title={<AccordionTitle>{title}</AccordionTitle>}
    >
      <List>
        {data.map(({ title: dataTitle }) => (
          <span key={dataTitle}>{dataTitle}</span>
        ))}
      </List>
    </Accordion.Element>
  )
}

type ArtistInfoProps = Pick<Data, 'awards' | 'press' | 'exhibitions' | 'cv'>

export function ArtistInfo({
  press,
  awards,
  exhibitions,
  cv,
}: ArtistInfoProps): ReactElement {
  const path = useAssetsPath()
  return (
    <Section>
      <FadeIn>
        <>
          <InfoWrap>
            <span>BIOGRAM</span>
            {cv && <a href={`${path}/${cv.name}`}>DOWNLOAD CV</a>}
          </InfoWrap>
          <Accordion>
            <DataList
              index={1}
              data={exhibitions}
              title="Selected Exhibitions"
            />
            <DataList index={2} data={awards} title="Awards" />
            <DataList index={3} data={press} title="Press" />
          </Accordion>
        </>
      </FadeIn>
    </Section>
  )
}
